/* eslint-disable no-nested-ternary */
import React from 'react'
import Icon from 'meinian-package/src/component/icon'
import moment from 'moment'
import classNames from 'classnames'
import link from 'meinian-package/src/utils/link'
import base from 'meinian-package/src/utils/base'
import { cdnImg } from 'meinian-package/src/utils/image'
import CollectGroupBtn from 'component/collectGroupBtn'
import styles from './index.module.less'

/**
 * 获取月销量数据
 * 下架超过30天不显示月销量
 * @param {*} sale30day
 * @param {*} cancelTime
 * @param {*} shelves
 */
function getMothSale({ saleDay, cancelTime, shelves }) {
  if ((shelves === 0 || shelves === 2) && cancelTime && moment(cancelTime).add(30, 'days').isBefore(moment())) {
    return '-'
  }
  return base.formatTaobaoVagueData(saleDay)
}
const map = {
  月销量: getMothSale,
  收藏: item => base.dyAutoFormatNumber(item.collect),
  销量: item => base.dyAutoFormatNumber(item.saleDay),
  评价: item => base.dyAutoFormatNumber(item.commentCount),
}

export default (props) => {
  const {
    tagFields = ['月销量'],
    footerFields = ['销量', '收藏', '评价'],
    minWidth,
    columnWidth,
    onClickCard,
    mainUrl,
    imageGroupEntityId,
    inspirationId,
    item = {},
  } = props
  const _itemDataDTO = item?.itemDataDTO || {}
  const title = _itemDataDTO?.itemTitle
  const price = (_itemDataDTO.price / 100)
  // const minPrice = (_itemDataDTO.historyMinLeftCprice / 100)
  const linkToTaobao = <Icon type="m-taob" className="link" onClick={(e) => { link.toTaobaoGoodDetail(item.itemId); e.stopPropagation() }} />
  const infoHeight = 150
  return <div
    className={classNames(styles['meinian-waterfall-card-item'])}
    key={`${imageGroupEntityId}${inspirationId}`}
    style={{
      minWidth,
      width: columnWidth,
      height: props.width ? Math.round((columnWidth * props.height) / props.width) + infoHeight : columnWidth,
      display: 'flex',
      flexDirection: 'column' }}
  >
    <div
      className="meinian-waterfall-card-image"
      style={{ height: `calc(100% - ${infoHeight}px)` }}
      onClick={e => {
        window.open(`/df/detail/image?blogIds=${item.imageGroupEntityId}&unionIds=${item.unionId}&platformId=${item.platformId}`)
        onClickCard?.(item, e)
      }}
    >
      <div className="image-card-top-mask">
        <div className="image-card-top-btn">
          <CollectGroupBtn currentBlog={{ ...item, ..._itemDataDTO }} />
        </div>
      </div>
      <img
        loading="lazy"
        src={cdnImg(mainUrl, 500)}
        style={{ width: '100%', height: '100%', objectFit: 'cover', background: 'linear-gradient(rgba(0,0,0,0.03), rgba(0,0,0,0.03))' }}
      />
    </div>
    <div className="card-info">
      <div className="card-price-wrap-wrap">
        <div className="card-price-wrap">
          <span className="card-price">¥{price}</span>
          {/* <span className="card-min-price">最低&nbsp;¥{minPrice}</span> */}
        </div>
        <div>{linkToTaobao}</div>
      </div>
      <div className="card-title">{title}</div>
      <div className="shop-wrapper">
        <span className="shop-name">
          <Icon type="m-dianpu" className="shop-name-icon" />
          <div className="shop-name-title">{_itemDataDTO.shopName || '未知店铺'}</div>
        </span>
        <span>{_itemDataDTO?.saleTime?.split(' ')[0]}上架</span>
      </div>
      <div className="card-tags">{tagFields.map(label => <span>{label}&nbsp;{map[label]?.(_itemDataDTO)}</span>)}</div>
      {footerFields?.length > 0 && <div className="card-footer">
        {footerFields.map(label => <span className="card-block-item">
          {label}
          <span style={{ color: 'var(--m-text-1)', marginLeft: '4px' }}>
            {map[label]?.(_itemDataDTO)}
          </span>
        </span>)}
      </div>}
    </div>
  </div>
}
